module.exports = __webpack_public_path__ + "img/csv.9ba4604b.svg";